<template>
  <form :class="bem.b()">
    <slot></slot>
  </form>
</template>

<script setup lang="ts">
import { createNamespace } from '@chenms-zj/utils/create'
import { FormContext, formContextKey, formProps } from './form'
import { onMounted, provide } from 'vue'
import { FormItemContext } from './form-item'
import { Values } from 'async-validator'

const bem = createNamespace('form')
defineOptions({
  name: 'cms-form'
})

const props = defineProps(formProps)

// 父级收集子集
const fields: FormItemContext[] = []

// form的校验，在父级中调用所有儿子的校验方法
const validate = async (
  callback?: (valid: boolean, fields?: Values) => void
) => {
  let errors: Values = {}
  for (const field of fields) {
    try {
      await field.validate('')
    } catch (error) {
      errors = {
        ...errors,
        ...(error as Values).fields
      }
    }
  }
  // 没有错误就返回成功
  if (Object.keys(errors).length === 0) {
    return callback?.(true)
  } else {
    // 有错误就返回失败
    if (callback) {
      callback?.(false, errors)
    } else {
      return Promise.reject(errors)
    }
  }
}

const addField: FormContext['addField'] = context => {
  fields.push(context)
}

const context: FormContext = {
  ...props,
  addField
}
provide(formContextKey, context)

// 将form表单的校验方法暴露给用户
defineExpose({
  validate
})
</script>

<style scoped></style>
